import axiosLimiter from '@/api/RateLimiter';

const farFutureDateISOString = new Date(9999, 1, 1).toISOString();

export default {
    async getCollectionPage(tenant: string, params: any): Promise<any> {

        let requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenant + '/readings?';

        //  Filters
        if('from' in params && params.from && params.from.length > 0) {
            requestURL = requestURL + '&from=' + encodeURIComponent(params.from);
        }
        if('until' in params && params.until && params.until.length > 0) {
            requestURL = requestURL + '&until=' + encodeURIComponent(params.until);
        }
        if('timestamp' in params && params.timestamp && params.timestamp.length > 0) {
            requestURL = requestURL + '&timestamp=' + encodeURIComponent(params.timestamp);
        }
        if('createdFrom' in params && params.createdFrom && params.createdFrom.length > 0) {
            requestURL = requestURL + '&createdFrom=' + encodeURIComponent(params.createdFrom);
        }
        if('createdUntil' in params && params.createdUntil && params.createdUntil.length > 0) {
            requestURL = requestURL + '&createdUntil=' + encodeURIComponent(params.createdUntil);
        }
        if('deviceId' in params && params.deviceId && params.deviceId.length > 0) {
            requestURL = requestURL + '&deviceId=' + encodeURIComponent(params.deviceId);
        }
        if('connectorId' in params && params.connectorId && params.connectorId.length > 0) {
            requestURL = requestURL + '&connectorId=' + encodeURIComponent(params.connectorId);
        }
        if('propertyId' in params && params.propertyId && params.propertyId.length > 0) {
            requestURL = requestURL + '&propertyId=' + encodeURIComponent(params.propertyId);
        }
        if('value' in params && params.value) {
            requestURL = requestURL + '&value=' + parseFloat(params.value);
        }
        if('flag' in params && params.flag) {
            requestURL = requestURL + '&flag=' + encodeURIComponent(params.flag);
        }
        if('deleted' in params && params.deleted) {
            requestURL = requestURL + '&deletedUntil=' + farFutureDateISOString;
        }
        if('applyFactor' in params && params.applyFactor !== undefined) {
            requestURL = requestURL + '&applyFactor=' + params.applyFactor;
        }
        
        // Paging
        if('itemsPerPage' in params && params.itemsPerPage) {
            requestURL = requestURL + '&page[size]=' + encodeURIComponent(params.itemsPerPage);
        }
        if('nextPageLink' in params && params.nextPageLink && params.nextPageLink.length > 0) {
            requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + params.nextPageLink;
        }
        if('prevPageLink' in params && params.prevPageLink && params.prevPageLink.length > 0) {
            requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + params.prevPageLink;
        }

        return axiosLimiter.get(requestURL);
    },
    async getAllCollectionPages(tenant: string, params: any = {}): Promise<any> {

        const requests = [];
        let currentPage = 1;
        let totalPages = null;
        let nextPageLink = null;
    
        while (totalPages === null || currentPage < totalPages+1) {
            let requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenant + '/readings?';

            //  Filters
            if('from' in params && params.from && params.from.length > 0) {
                requestURL = requestURL + '&from=' + encodeURIComponent(params.from);
            }
            if('until' in params && params.until && params.until.length > 0) {
                requestURL = requestURL + '&until=' + encodeURIComponent(params.until);
            }
            if('timestamp' in params && params.timestamp && params.timestamp.length > 0) {
                requestURL = requestURL + '&timestamp=' + encodeURIComponent(params.timestamp);
            }
            if('createdFrom' in params && params.createdFrom && params.createdFrom.length > 0) {
                requestURL = requestURL + '&createdFrom=' + encodeURIComponent(params.createdFrom);
            }
            if('createdUntil' in params && params.createdUntil && params.createdUntil.length > 0) {
                requestURL = requestURL + '&createdUntil=' + encodeURIComponent(params.createdUntil);
            }
            if('deviceId' in params && params.deviceId && params.deviceId.length > 0) {
                requestURL = requestURL + '&deviceId=' + encodeURIComponent(params.deviceId);
            }
            if('connectorId' in params && params.connectorId && params.connectorId.length > 0) {
                requestURL = requestURL + '&connectorId=' + encodeURIComponent(params.connectorId);
            }
            if('propertyId' in params && params.propertyId && params.propertyId.length > 0) {
                requestURL = requestURL + '&propertyId=' + encodeURIComponent(params.propertyId);
            }
            if('value' in params && params.value) {
                requestURL = requestURL + '&value=' + parseFloat(params.value);
            }
            if('flag' in params && params.flag) {
                requestURL = requestURL + '&flag=' + encodeURIComponent(params.flag);
            }
            if('deleted' in params && params.deleted) {
                requestURL = requestURL + '&deletedUntil=' + farFutureDateISOString;
            }
            if('applyFactor' in params && params.applyFactor !== undefined) {
                requestURL = requestURL + '&applyFactor=' + params.applyFactor;
            }

            if(nextPageLink) {
                requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + nextPageLink;
            }
            const response: Promise<any> = axiosLimiter.get(requestURL);

            if (totalPages === null || currentPage < totalPages+1) {
                const results: any = await response;
                totalPages = parseInt(results.data.meta.page.totalPages);
                nextPageLink = results.data.links.next;
            }
            requests.push(response);
            currentPage++;
        }
    
        return Promise.all(requests);
    },
    async getAggregationPage(tenantId: string, deviceId: string, interval: string, frequency: string, aggFunction: string, params: any = {}): Promise<any> {

        let requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantId + '/readings/aggregates?';
        requestURL += '&deviceId=' + encodeURIComponent(deviceId);
        requestURL += '&frequency=' + encodeURIComponent(frequency);
        requestURL += '&interval=' + encodeURIComponent(interval);
        requestURL += '&function=' + encodeURIComponent(aggFunction);

        //  Filters
        if('from' in params && params.from && params.from.length > 0) {
            requestURL = requestURL + '&from=' + encodeURIComponent(params.from);
        }
        if('until' in params && params.until && params.until.length > 0) {
            requestURL = requestURL + '&until=' + encodeURIComponent(params.until);
        }
        if('applyFactor' in params && params.applyFactor !== undefined) {
            requestURL = requestURL + '&applyFactor=' + params.applyFactor;
        }

        // Paging
        if('itemsPerPage' in params && params.itemsPerPage) {
            requestURL = requestURL + '&page[size]=' + encodeURIComponent(params.itemsPerPage);
        }
        if('nextPageLink' in params && params.nextPageLink && params.nextPageLink.length > 0) {
            requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + params.nextPageLink;
        }
        if('prevPageLink' in params && params.prevPageLink && params.prevPageLink.length > 0) {
            requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + params.prevPageLink;
        }

        return axiosLimiter.get(requestURL);
    },
    async getAllAggregationPages(tenantId: string, deviceId: string, interval: string, frequency: string, aggFunction: string, params: any = {}): Promise<any> {

        const requests = [];
        let currentPage = 1;
        let totalPages = null;
        let nextPageLink = null;
    
        while (totalPages === null || currentPage < totalPages+1) {
            let requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantId + '/readings/aggregates?';
            requestURL += '&deviceId=' + encodeURIComponent(deviceId);
            requestURL += '&frequency=' + encodeURIComponent(frequency);
            requestURL += '&interval=' + encodeURIComponent(interval);
            requestURL += '&function=' + encodeURIComponent(aggFunction);
            // console.log(requestURL);

            //  Filters
            if('from' in params && params.from && params.from.length > 0) {
                requestURL = requestURL + '&from=' + encodeURIComponent(params.from);
            }
            if('until' in params && params.until && params.until.length > 0) {
                requestURL = requestURL + '&until=' + encodeURIComponent(params.until);
            }
            if('applyFactor' in params && params.applyFactor !== undefined) {
                requestURL = requestURL + '&applyFactor=' + params.applyFactor;
            }

            if(nextPageLink) {
                requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + nextPageLink;
            }
            const response: Promise<any> = axiosLimiter.get(requestURL);

            if (totalPages === null || currentPage < totalPages+1) {
                const results: any = await response;
                totalPages = parseInt(results.data.meta.page.totalPages);
                nextPageLink = results.data.links.next;
            }
            requests.push(response);
            currentPage++;
        }
    
        return Promise.all(requests);
    },
    async getAllGroupAggregationPages(tenantId: string, filters: any[], interval: number, frequency: string, aggFunction: string, params: any = {}): Promise<any> {

        const requests = [];
        let currentPage = 1;
        let totalPages = null;
        let nextPageLink = null;
    
        while (totalPages === null || currentPage < totalPages+1) {
            let requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantId + '/readings/aggregates?';
            // console.log(requestURL);

            const body = {
                "data": {
                    "type": "group-aggregates",
                    "attributes": {
                        "frequency": frequency.toUpperCase(),
                        "interval": interval,
                        "function": aggFunction.toUpperCase(),
                        "filters": filters
                    }
                }
            } as any;

            if(nextPageLink) {
                requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + nextPageLink;
            }
            const response: Promise<any> = axiosLimiter.post(requestURL, JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});

            if (totalPages === null || currentPage < totalPages+1) {
                const results: any = await response;
                totalPages = parseInt(results.data.meta.page.totalPages);
                nextPageLink = results.data.links.next;
            }
            requests.push(response);
            currentPage++;
        }
    
        return Promise.all(requests);
    },
    getSingle(tenant: string, readingUUID: string, applyFactor?: boolean): Promise<any> {

        let query = "?";
        if(applyFactor !== undefined) {
            query = query + '&applyFactor=' + applyFactor;
        }

        return axiosLimiter.get(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenant + '/readings/' + readingUUID + query);
    },
    createReading(tenantUUID: string, value: number, timestamp: string, deviceUUID: string, flag?: string): Promise<any> {
    
        const body = {
            data: {
                type: "readings",
                attributes: {
                    value: value,
                    timestamp: timestamp
                },
                relationships: {
                    device: {
                        data: {
                            type: "devices",
                            id: deviceUUID
                        }
                    }
                }
            }
        } as any;

        if(flag && flag.length > 0) {
            body.data.attributes.flag = flag;
        }

        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/readings/', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    updateReading(tenantUUID: string, readingUUID: string, value = "", deviceUUID = "", flag="", factor?: number): Promise<any> {
        
        const body = {
            data: {
                type: "readings",
                id: readingUUID,
                attributes: {
                }
            }
        } as any;

        if(value.length > 0) {
            body.data.attributes.value = parseFloat(value);
        }
        if(flag == null || flag.length > 0) {
            body.data.attributes.flag = flag;
        }
        // Update timestamp makes problems
        // if(timestamp.length > 0) {
        //     body.data.attributes.timestamp = timestamp;
        // }
        if(factor !== undefined) {
            body.data.attributes.factor = factor;
        }

        if(deviceUUID.length > 0) {
            body.data.relationships = {
                device: {
                    data: {
                        type: "devices",
                        id: deviceUUID
                    }
                }
            };
        }

        return axiosLimiter.patch(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/readings/' + readingUUID, JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    deleteReading(tenantUUID: string, readingUUID: string): Promise<any> {
        return axiosLimiter.delete(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/readings/' + readingUUID);
    },
    restoreReading(tenantUUID: string, readingUUID: string): Promise<any> {

        const body = {
            data: {
                type: "readings",
                id: readingUUID
            }
        } as any;

        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/readings/' + readingUUID,  JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    getAssociatedDevice(tenantUUID: string, readingUUID: string): Promise<any> {
        return axiosLimiter.get(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/readings/' + readingUUID + '/device');
    },
    batchCreate(tenantUUID: string, readings: { value: number, timestamp: string, deviceId: string, flag?: string }[], withoutResults=false) {

        const body = {
            data: []
        } as any;
    
        for(const reading of readings) {
            body.data.push(
                {
                    type: "readings",
                    attributes: {
                        value: reading.value,
                        timestamp: reading.timestamp,
                        flag: reading?.flag,
                    },
                    relationships: {
                        device: {
                            data: {
                                type: "devices",
                                id: reading.deviceId
                            }
                        }
                    }
                }
            )
        }
    
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/tenants/' + tenantUUID + '/readings?withoutResults=' + String(withoutResults), JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json' }});
    }
}
  